import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCreative } from '../selectors';
import { Tag } from '@myua/kit';
import * as viewerActions from '../actions';

export const CreativeFilter = () => {
  const dispatch = useDispatch();
  const creative = useSelector(getCreative);
  if (!creative) {
    return null;
  }

  return (
    <div className="al-viewer-creative-filter">
      Filter by creative:{' '}
      <Tag
        className="al-viewer-creative-filter__tag"
        closable
        color="blue"
        onClose={(e) => {
          e.preventDefault();
          dispatch(viewerActions.creativeChanged({ creative: undefined, loadAssets: true }));
        }}
      >
        <span className="al-viewer-creative-filter__text">{creative.name}</span>
      </Tag>
    </div>
  );
};
